import { PublicKey } from "@solana/web3.js";
import QuestConfig from "../components/Pages/Quests/QuestConfig.json"
import { facade } from "../helpers/analytic/AnalyticFacade";
import { QuestCompletedEvent } from "../helpers/analytic/event/QuestCompletedEvent";
import { APIResult } from "./APIResult";


export function getCurrentQuest(): number {

    let item = localStorage.getItem("quest");

    if (item) {
        return parseInt(item);
    }

    return 0;
}


export function getQuestsLs(): any {

    let res = {
        quests: [QuestConfig[0]],
        points: 0
    }

    let lsItem = localStorage.getItem("quests");

    if (lsItem) {
        let lsObj = JSON.parse(lsItem);

        res = {
            quests: lsObj.quests,
            points: lsObj.points
        }
    }

    return res;
}


export function updateQuestsLs(result: APIResult) {

    if (result.status >= 0 && result.data) {
        let points = 0;
        let nextQuests = [];
        let completedQuests = [];

        // Get nextQuests from backend!
        for (let i = 0; i < result.data.nextQuests.length; i++) {
            let backNq = result.data.nextQuests[i];
            let clientConf = QuestConfig.find((c: any) => c.id === backNq.id);

            if (clientConf) {
                nextQuests.push({
                    ...clientConf,
                    status: backNq.status
                })
            }
        }

        let currentQuestsStatus = getQuestsLs().quests;


        console.log("API RESULT ", result)
        // Get completedQuests from backend!
        for (let i = 0; i < result.data.completedQuests.length; i++) {
            let backCq = result.data.completedQuests[i];
            let clientConf = QuestConfig.find((c: any) => c.id === backCq.id);

            if (clientConf) {
                points += clientConf.reward;

                //Can t figure out a way to send event from backend to Firebase Analytic
                //Will need to be remove when we update our anlytic system
                if (currentQuestsStatus.findIndex((c: any) => c.id === backCq.id && c.status === 2) == -1 && backCq.status === 2) {
                    facade.sendEvent(new QuestCompletedEvent(backCq.id))
                }

                completedQuests.push({
                    ...clientConf,
                    status: backCq.status
                })
            }
        }

        let updateObj: any = {
            quests: [...completedQuests, ...nextQuests],
            points
        }

        //console.log("UPDATES OBJ  ", updateObj, completedQuests, nextQuests);

        localStorage.setItem("quests", JSON.stringify(updateObj));
    }
}

export function getWalletAddress(): string | null {

    let address: string | null = localStorage.getItem("address");
    return address;

}

export function saveWalletAddress(publicKey: PublicKey | null) {

    if (publicKey != null) {
        localStorage.setItem("address", publicKey.toBase58());
    }
}
